import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Attachments, DescriptionWrapper } from "~/components/ModalObjects";
import { TemplateTaskDependencies } from "~/pages/ProjectTemplates/Tasks/Dependencies/TemplateTaskDependencies";
import { fetchProjectTemplateElement } from "~/store/actions/actions.projectTemplateElements";
import { getProjectTemplateElementById } from "~/store/selectors/selector.projectTemplateElements";
import { TemplateSubtasks } from "./Subtasks/TemplateSubtasks";
import TemplateTaskHeader from "./TemplateTaskHeader";
import { PROJECT_TEMPLATE_TASK } from "../utils";

export const TemplateTaskBody = ({ taskId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const task = useSelector((state) => getProjectTemplateElementById(state, taskId));
  const templateId = task.template_id;

  useEffect(() => {
    dispatch(fetchProjectTemplateElement(templateId, taskId));
  }, [dispatch, taskId, templateId]);

  const handleDblClick = useCallback(() => {
    navigate(location.pathname + location.search, {
      replace: true,
      state: { edit: true },
    });
  }, [location.pathname, location.search, navigate]);

  return (
    <>
      <TemplateTaskHeader
        task={task}
        className="tw-mb-6"
      />
      <DescriptionWrapper
        parentId={taskId}
        parentType={PROJECT_TEMPLATE_TASK}
        body={task?.body_formatted}
        className={classNames("tw-mb-4 tw-border-b tw-border-solid tw-border-0 tw-border-border-primary", {
          "tw-pb-4": task?.body_formatted,
        })}
        onDoubleClick={handleDblClick}
      />
      {task?.attachments.length > 0 ? (
        <Attachments
          id={taskId}
          type={PROJECT_TEMPLATE_TASK}
          className="tw-mb-4 tw-border-b tw-border-solid tw-border-0 tw-border-border-primary"
        />
      ) : null}
      <TemplateSubtasks
        taskId={taskId}
        templateId={task?.template_id}
        isHiddenFromClients={task?.is_hidden_from_clients}
        className="tw-mb-4 tw-pb-4 tw-border-b tw-border-solid tw-border-0 tw-border-border-primary"
      />
      <TemplateTaskDependencies
        taskId={taskId}
        taskListId={task?.task_list_id}
        templateId={task?.template_id}
      />
    </>
  );
};

TemplateTaskBody.propTypes = {
  taskId: PropTypes.number,
};
